import { type Stacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';

export const enableStackletPrivateIP = (id: number): Promise<{ stacklet: Stacklet }> =>
  request({
    url: `/stacklets/${id}/`,
    method: 'POST',
    data: { action: 'enable_private_networking' },
  });
